module.exports = __webpack_public_path__ + "static/media/ic-airplane-plus.17aff82c.svg";